import { adCustomizersStyle } from '@bingads-webui-campaign-react/common-styles';

export const getDSAStyles = (_, { palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  dsa: {
    ...adCustomizersStyle({ palette, iconFontFamily }),

    '& .field-label': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
    },
  },
});
